const VIEW_NOTES_FOCUS = "notes-focus";
const KEY = "weektodo";

let current = null;
const listeners = new Set();
let pendingBody = null;

function notify() {
  listeners.forEach((fn) => {
    try {
      fn(current);
    } catch (e) {
      console.error(e);
    }
  });
}

function parseHash(hash) {
  if (!hash || typeof hash !== "string") return null;
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  if (raw === "notes/focus") return { noteId: null };
  const m = /^notes\/focus\/([^/]+)$/.exec(raw);
  if (!m) return null;
  const noteId = decodeURIComponent(m[1]);
  return noteId ? { noteId } : { noteId: null };
}

function readState(state) {
  if (!state || !state[KEY]) return null;
  const nav = state[KEY];
  if (nav.view !== VIEW_NOTES_FOCUS) return null;
  if (nav.noteId == null || nav.noteId === "") return { noteId: null };
  return { noteId: String(nav.noteId) };
}

function focusUrl(noteId) {
  if (typeof window === "undefined") return "";
  const path = noteId
    ? `#notes/focus/${encodeURIComponent(noteId)}`
    : "#notes/focus";
  return `${window.location.pathname}${window.location.search}${path}`;
}

function onPopState(event) {
  current = readState(event.state);
  if (!current && typeof window !== "undefined") {
    current = parseHash(window.location.hash);
  }
  notify();
}

let listening = false;

function ensureListen() {
  if (listening || typeof window === "undefined") return;
  listening = true;
  window.addEventListener("popstate", onPopState);
  current = readState(window.history.state);
  if (!current) current = parseHash(window.location.hash);
}

function clearTodoDetailIfOpen() {
  try {
    const { getTodoDetail, clearTodoDetail } = require("./mobileNav.js");
    if (getTodoDetail()) clearTodoDetail();
  } catch (_) {
    /* ignore */
  }
}

/**
 * @param {{ noteId?: string|null }} [opts]
 * @returns {{ noteId: string|null }}
 */
function openNotesFocus(opts = {}) {
  ensureListen();
  clearTodoDetailIfOpen();
  const noteId =
    opts.noteId == null || opts.noteId === "" ? null : String(opts.noteId);
  const payload = { noteId };
  const state = { [KEY]: { view: VIEW_NOTES_FOCUS, noteId } };
  const url = focusUrl(noteId);
  window.history.pushState(state, "", url || undefined);
  current = payload;
  notify();
  return payload;
}

function closeNotesFocus() {
  ensureListen();
  if (!current) return;
  window.history.back();
}

function clearNotesFocus() {
  ensureListen();
  if (!current) return;
  current = null;
  if (typeof window !== "undefined") {
    const url = `${window.location.pathname}${window.location.search}`;
    window.history.replaceState({}, "", url);
  }
  notify();
}

/**
 * After first auto-create, keep the same history entry but attach id.
 * @param {string} noteId
 */
function upgradeNotesFocusId(noteId) {
  ensureListen();
  if (!noteId) return;
  const id = String(noteId);
  const payload = { noteId: id };
  const state = { [KEY]: { view: VIEW_NOTES_FOCUS, noteId: id } };
  const url = focusUrl(id);
  window.history.replaceState(state, "", url || undefined);
  current = payload;
  notify();
}

function getNotesFocus() {
  ensureListen();
  return current;
}

function subscribeNotesFocus(listener) {
  ensureListen();
  listeners.add(listener);
  listener(current);
  return () => listeners.delete(listener);
}

function setNotesFocusPendingBody(body) {
  pendingBody = body == null ? null : String(body);
}

function takeNotesFocusPendingBody() {
  const value = pendingBody;
  pendingBody = null;
  return value;
}

module.exports = {
  VIEW_NOTES_FOCUS,
  parseHash,
  openNotesFocus,
  closeNotesFocus,
  clearNotesFocus,
  upgradeNotesFocusId,
  getNotesFocus,
  subscribeNotesFocus,
  setNotesFocusPendingBody,
  takeNotesFocusPendingBody,
};
